"use strict";
// tslint:disable:deprecation
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericFlyoutListMenuWidget = exports.FlyoutListMenuStyles = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var TabStyles_1 = require("../styles/TabStyles");
var DomUtil_1 = require("../utils/DomUtil");
var GlobalPointerDownOutsideListener_1 = require("../utils/GlobalPointerDownOutsideListener");
var Overlay_1 = require("../utils/Overlay");
var ListMenuWidget_1 = require("./ListMenuWidget");
var DefaultAnchorOrigin = {
    vertical: Overlay_1.VerticalOriginOption.bottom,
    horizontal: Overlay_1.HorizontalOriginOption.left
};
var Sizing = TabStyles_1.TabStyles.Sizing, Colors = TabStyles_1.TabStyles.Colors, Shadow = TabStyles_1.TabStyles.Shadow;
exports.FlyoutListMenuStyles = {
    backgroundColor: 'white',
    borderColor: Colors.L6,
    borderRadius: Sizing.BorderRadius,
    borderStyle: 'solid',
    borderWidth: Sizing.BorderWidth,
    boxShadow: Shadow.Standard
};
var GenericFlyoutListMenuWidget = /** @class */ (function (_super) {
    tslib_1.__extends(GenericFlyoutListMenuWidget, _super);
    function GenericFlyoutListMenuWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.flyoutDomNode = null;
        _this.setFlyoutDomNode = function (ref) {
            _this.flyoutDomNode = ref;
        };
        _this.getAnchorClientRect = function () {
            if (_this.props.getAnchorClientRect) {
                return _this.props.getAnchorClientRect();
            }
            return _this.props.anchorEl ? _this.props.anchorEl.getBoundingClientRect() : undefined;
        };
        return _this;
    }
    GenericFlyoutListMenuWidget.prototype.componentDidMount = function () {
        // Everything outside the toggling element/button or the flyout should trigger a close on mousedown
        if (this.flyoutDomNode) {
            this.unsubscribeFlyoutFromGlobalListener = GlobalPointerDownOutsideListener_1.GlobalPointerDownOutsideListener.subscribe(this.flyoutDomNode, this.props.requestCloseAll);
        }
        if (this.props.toggleEl) {
            this.unsubscribeToggleElFromGlobalListener = GlobalPointerDownOutsideListener_1.GlobalPointerDownOutsideListener.subscribe(this.props.toggleEl, this.props.requestCloseAll);
        }
    };
    GenericFlyoutListMenuWidget.prototype.componentWillUnmount = function () {
        if (this.unsubscribeFlyoutFromGlobalListener) {
            this.unsubscribeFlyoutFromGlobalListener();
        }
        if (this.unsubscribeToggleElFromGlobalListener) {
            this.unsubscribeToggleElFromGlobalListener();
        }
        // Return focus to the toggle element
        if (this.props.toggleEl && this.props.shouldReturnFocusToToggleEl) {
            /**
             * We must use setTimeout here because it is likely a focus event is causing the flyoutlistmenu to unmount.
             * We need to queue this event so that it is called after that focus event.
             */
            DomUtil_1.timeoutFocus(this.props.toggleEl);
        }
    };
    GenericFlyoutListMenuWidget.prototype.render = function () {
        var overlayProps = {
            allowAutoPosition: this.props.allowAutoPosition,
            anchorOrigin: this.props.anchorOrigin || DefaultAnchorOrigin,
            getAnchorClientRect: this.getAnchorClientRect,
            handleScrollOnScrollingRoot: this.props.handleScrollOnScrollingRoot,
            leftFromOverlaidPosition: this.props.leftFromOverlaidPosition,
            scrollingRootId: this.props.scrollingRootId,
            shouldAutoPositionOnScrollingRootScroll: this.props.shouldAutoPositionOnScrollingRootScroll,
            stackedOrigin: this.props.stackedOrigin,
            stackingRootId: this.props.stackingRootId,
            topFromOverlaidPosition: this.props.topFromOverlaidPosition,
            zIndex: this.props.zIndex,
        };
        var containerProps = {
            onMouseEnter: this.props.onMouseEnter,
            ref: this.setFlyoutDomNode,
            style: tslib_1.__assign(tslib_1.__assign({}, exports.FlyoutListMenuStyles), this.props.menuStyle),
        };
        var listMenuProps = {
            __INTERNAL__focusIndex: this.props.__INTERNAL__focusIndex,
            id: this.props.id,
            maxHeight: this.props.maxHeight,
            menuItemInfos: this.props.menuItemInfos,
            onEscapeKeyUp: this.props.onEscapeKeyUp,
            onLeftArrowKeyDown: this.props.onLeftArrowKeyDown,
            onSelect: this.props.onSelect,
            // TFS1018850 Make sure GlobalPointerDownOutsideListener subscribes to the same closeHandler as its submenus
            requestCloseAll: this.props.requestCloseAll,
            role: this.props.role,
            scrollingRootId: this.props.scrollingRootId,
            stackingRootId: this.props.stackingRootId,
            subMenuAllowAutoPosition: this.props.allowAutoPosition,
            subMenuShouldAutoPositionOnScrollingRootScroll: this.props.shouldAutoPositionOnScrollingRootScroll,
            testId: this.props.testId,
            zIndex: this.props.zIndex,
        };
        return (React.createElement(Overlay_1.Overlay, tslib_1.__assign({}, overlayProps),
            React.createElement("div", tslib_1.__assign({}, containerProps),
                React.createElement(ListMenuWidget_1.ListMenuWidget, tslib_1.__assign({}, listMenuProps)))));
    };
    GenericFlyoutListMenuWidget.defaultProps = {
        role: 'menu',
        shouldReturnFocusToToggleEl: true,
    };
    return GenericFlyoutListMenuWidget;
}(React.Component));
exports.GenericFlyoutListMenuWidget = GenericFlyoutListMenuWidget;
//# sourceMappingURL=FlyoutListMenuWidget.js.map